module.exports = __webpack_public_path__ + "img/UTFRON-4.9be7b395.jpg";